var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "section" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "columns" }, [
        _c(
          "div",
          { staticClass: "column" },
          [
            _c("sidebar", {
              attrs: { newRequestButtonEnable: _vm.newRequestButtonEnable },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "column is-9" },
          [
            _c("router-view", {
              on: {
                "enable-new-request-button": _vm.enableNewRequestButton,
                "disable-new-request-button": _vm.disableNewRequestButton,
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }